import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Divider,
  Card,
  CardContent,
  CardHeader,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  ListItemIcon,
  Dialog,
  DialogContent,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CircleIcon from '@mui/icons-material/FiberManualRecord';

const Documentation = () => {
  const navigate = useNavigate();
  const [openVideo, setOpenVideo] = useState(false);
  const [currentVideo, setCurrentVideo] = useState('');

  const videos = {
    generalDescription: 'https://res.cloudinary.com/drngbvco0/video/upload/v1733682509/full_description_etony4.mp4',
    landingPage: 'https://res.cloudinary.com/drngbvco0/video/upload/v1733682519/landing_page_oflel5.mp4',
    projectManagement: 'https://res.cloudinary.com/drngbvco0/video/upload/v1733682524/project_managment_rub5ol.mp4',
    stakeholderManagement: 'https://res.cloudinary.com/drngbvco0/video/upload/v1733682508/stakeholder_managment_ep4ws6.mp4',
    ICT_Statistics: 'https://res.cloudinary.com/drngbvco0/video/upload/v1733682521/ictStatstice_nmegmc.mp4',
    riskManagement: 'https://res.cloudinary.com/drngbvco0/video/upload/v1733682497/risk_management_wa9ibd.mp4',
    userManagement: 'https://res.cloudinary.com/drngbvco0/video/upload/v1733682485/user-management_vmibej.mp4',
    projectDeshboard: 'https://res.cloudinary.com/drngbvco0/video/upload/v1733682534/project_deshboard_gckvon.mp4',
    map: 'https://res.cloudinary.com/drngbvco0/video/upload/v1733682534/map_cui3oa.mp4',
   forgotPassword: 'https://res.cloudinary.com/drngbvco0/video/upload/v1733682495/forgot_password_ufewg0.mp4',
   budget: 'https://res.cloudinary.com/drngbvco0/video/upload/v1733682499/budget_jrbl1t.mp4',
   reminder: 'https://res.cloudinary.com/drngbvco0/video/upload/v1733682502/reminder_az0hre.mp4',
   reporting: 'https://res.cloudinary.com/drngbvco0/video/upload/v1733682519/reporting_ztvjd9.mp4',
    

    
    systemIntegration: 'https://res.cloudinary.com/your-integration-video-url',
    security: 'https://res.cloudinary.com/your-security-video-url',
    communication: 'https://res.cloudinary.com/your-communication-video-url',
    customization: 'https://res.cloudinary.com/your-customization-video-url'
  };

  const handleOpenVideo = (videoUrl) => {
    setCurrentVideo(videoUrl);
    setOpenVideo(true);
  };
  const handleCloseVideo = () => setOpenVideo(false);

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ backgroundColor: 'white', maxWidth: '100%', marginRight:'24px'}}>
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom 
        align="center"
        sx={{ fontSize: '2.5rem' }} 
      >
        Documentation & Training
      </Typography>
      <Divider sx={{ marginBottom: 4 }} />

      <Typography 
        variant="h5" 
        component="h2" 
        gutterBottom 
        sx={{ marginLeft: '5px', fontWeight: 'bold', textDecoration: 'underline', fontSize: '1.75rem' }}  
      >
        Admin & User Manuals
      </Typography>
      <ListItemButton onClick={() => handleOpenVideo(videos.generalDescription)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="General description" 
                secondary="A centralized information portal facilitating cross-border collaboration, project management, and data exchange between COMESA member states in Eastern Africa, Southern Africa, and Indian Ocean regions through secure, multi-lingual, and real-time interactive interfaces."
                primaryTypographyProps={{ fontSize: '1.2rem' }}  
                secondaryTypographyProps={{ fontSize: '1rem' }}  
              />
            </ListItemButton>
            <ListItemButton onClick={() => handleOpenVideo(videos.landingPage)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="Landing Page" 
                secondary="A dynamic entry portal showcasing COMESA's key initiatives with real-time project highlights, interactive regional statistics, and secure login access for stakeholders across Eastern Africa, Southern Africa, and Indian Ocean regions."
                primaryTypographyProps={{ fontSize: '1.2rem' }}  
                secondaryTypographyProps={{ fontSize: '1rem' }}  
              />
            </ListItemButton>

     
      <Card sx={{ marginBottom: 4 }}>
        <CardHeader 
          title={
            <Typography 
              variant="h6" 
              sx={{ fontWeight: 'bold', textDecoration: 'underline', fontSize: '1.5rem' }}  
            >
              Administrator Manual
            </Typography>
          } 
        />
        <CardContent>
          <Typography variant="body1" gutterBottom sx={{ fontSize: '1.25rem' }}>  
            The Administrator Manual includes instructions for managing various aspects of the portal, ensuring secure and efficient use of the system.
          </Typography>
          <List>
            <ListItemButton onClick={() => handleOpenVideo(videos.projectManagement)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="Project Management" 
                secondary="Create, update, and manage projects dynamically. Assign stakeholders with diverse roles. Link projects to quarterly budgets."
                primaryTypographyProps={{ fontSize: '1.2rem' }}  
                secondaryTypographyProps={{ fontSize: '1rem' }}  
              />
            </ListItemButton>
            <ListItemButton onClick={() => handleOpenVideo(videos.stakeholderManagement)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="Stakeholder Management" 
                secondary="Add and update stakeholder or organization data."
                primaryTypographyProps={{ fontSize: '1.2rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
              />
            </ListItemButton>
            <ListItemButton onClick={() => handleOpenVideo(videos.ICT_Statistics)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="ICT Statistics" 
                secondary="A comprehensive form-based interface for tracking and managing ICT infrastructure progress metrics across COMESA member states and regional networks, including project outputs, indicators, baselines, and achievement targets."
                primaryTypographyProps={{ fontSize: '1.2rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
              />
            </ListItemButton>
            <ListItemButton onClick={() => handleOpenVideo(videos.riskManagement)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="Risk Management" 
                secondary="Capture risks and assign mitigation strategies. Set up alerts for delayed or escalating risks."
                primaryTypographyProps={{ fontSize: '1.2rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
              />
            </ListItemButton>
            <ListItemButton onClick={() => handleOpenVideo(videos.userManagement)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="User Management" 
                secondary="Role-based access control for managing permissions. Enable multi-factor authentication (MFA). Manage users, roles, and permissions through an admin portal."
                primaryTypographyProps={{ fontSize: '1.2rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
              />
            </ListItemButton>
            <ListItemButton onClick={() => handleOpenVideo(videos.projectDeshboard)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="Project Deshboard" 
                secondary="Generate custom reports filtered by project or country. Export reports in multiple formats such as PDF, Word, or Excel. Display trends through visual analytics, graphs, and charts."
                primaryTypographyProps={{ fontSize: '1.2rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
              />
            </ListItemButton>
            <ListItemButton onClick={() => handleOpenVideo(videos.map)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="Map" 
                secondary="An interactive geospatial visualization component that displays COMESA project locations across Africa with clustered markers, custom popups, and filterable views by organization and project name using React-Leaflet and OpenStreetMap."
                primaryTypographyProps={{ fontSize: '1.2rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
              />
            </ListItemButton>
            <ListItemButton onClick={() => handleOpenVideo(videos.forgotPassword)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="Forgot Password" 
                secondary="A secure password recovery system that verifies user identity through OTP sent via SMS/email, enabling users to safely reset their COMESA portal credentials using Twilio and Gmail SMTP services."
                primaryTypographyProps={{ fontSize: '1.2rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
              />
            </ListItemButton>
            <ListItemButton onClick={() => handleOpenVideo(videos.budget)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="Budget" 
                secondary="A multi-currency budget management interface that allows users to track expected vs actual project budgets with automated USD conversion, supporting 9 regional currencies and role-based access for COMESA stakeholders."
                primaryTypographyProps={{ fontSize: '1.2rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
              />
            </ListItemButton>
            <ListItemButton onClick={() => handleOpenVideo(videos.reminder)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="Reminder" 
                secondary="An automated notification system that sends timely alerts for upcoming project deadlines, meetings, and milestones through SMS and email channels with configurable frequency and recipient groups."
                primaryTypographyProps={{ fontSize: '1.2rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
              />
            </ListItemButton>
            <ListItemButton onClick={() => handleOpenVideo(videos.reporting)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="Reporting" 
                secondary="A comprehensive reporting system that generates detailed project insights with multi-format export capabilities (PDF/Excel), customizable filters, and dynamic data visualization for COMESA stakeholders across different regional networks and member states."
                primaryTypographyProps={{ fontSize: '1.2rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
              />
            </ListItemButton>
            <ListItemButton onClick={() => handleOpenVideo(videos.systemIntegration)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="Integration with Systems" 
                secondary="Connect with COMESA and REC systems via APIs. Sync data across platforms in real-time."
                primaryTypographyProps={{ fontSize: '1.2rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
              />
            </ListItemButton>
            <ListItemButton onClick={() => handleOpenVideo(videos.security)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="Security" 
                secondary="Encrypt data in transit with SSL and at rest using AES-256. Set inactivity timeouts, lockout policies, and track audit logs."
                primaryTypographyProps={{ fontSize: '1.2rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
              />
            </ListItemButton>
            <ListItemButton onClick={() => handleOpenVideo(videos.communication)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="Communication" 
                secondary="Set up automated email alerts and internal messaging for users. Use an action tracker to manage pending tasks and reminders."
                primaryTypographyProps={{ fontSize: '1.2rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
              />
            </ListItemButton>
            <ListItemButton onClick={() => handleOpenVideo(videos.customization)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="Customization" 
                secondary="Customize theming and adhere to corporate identity guidelines. Add new projects dynamically and update dropdown lists."
                primaryTypographyProps={{ fontSize: '1.2rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
              />
            </ListItemButton>
          </List>
        </CardContent>
      </Card>

      
      <Card sx={{ marginBottom: 4 }}>
        <CardHeader 
          title={
            <Typography 
              variant="h6" 
              sx={{ fontWeight: 'bold', textDecoration: 'underline', fontSize: '1.5rem' }}  
            >
              User Manual
            </Typography>
          } 
        />
        <CardContent>
          <Typography variant="body1" gutterBottom sx={{ fontSize: '1.25rem' }}>
            The User Manual provides step-by-step instructions on how to interact with the system.
          </Typography>
          <List>
            <ListItemButton onClick={() => handleOpenVideo(videos.projectManagement)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="Project Management" 
                secondary="View and track project outcomes, outputs, and activities in real-time. Monitor linked budget allocations per project."
                primaryTypographyProps={{ fontSize: '1.2rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
              />
            </ListItemButton>
            <ListItemButton onClick={() => handleOpenVideo(videos.stakeholderManagement)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="Stakeholder Management" 
                secondary="Access and update stakeholder information."
                primaryTypographyProps={{ fontSize: '1.2rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
              />
            </ListItemButton>
            {/* <ListItemButton>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="M&E Module" 
                secondary="Input and view performance indicators and monitor KPI trends."
                primaryTypographyProps={{ fontSize: '1.2rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
              />
            </ListItemButton> */}
            <ListItemButton onClick={() => handleOpenVideo(videos.riskManagement)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="Risk Management" 
                secondary="View captured risks and receive notifications on risk escalation."
                primaryTypographyProps={{ fontSize: '1.2rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
              />
            </ListItemButton >
            <ListItemButton onClick={() => handleOpenVideo(videos.userManagement)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="User Management" 
                secondary="Ensure proper access based on roles and authentication methods."
                primaryTypographyProps={{ fontSize: '1.2rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
              />
            </ListItemButton>
          </List>
        </CardContent>
      </Card>

    
      <Card>
        <CardHeader 
          title={
            <Typography 
              variant="h6" 
              sx={{ fontWeight: 'bold', textDecoration: 'underline', fontSize: '1.5rem' }} 
            >
              Training Program
            </Typography>
          } 
        />
        <CardContent>
          <Typography variant="body1" gutterBottom sx={{ fontSize: '1.25rem' }}>
            To ensure users and administrators from RECs are well-versed with the system, a comprehensive training program will be provided:
          </Typography>
          <List>
            <ListItemButton onClick={() => handleOpenVideo(videos.security)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="Training for Administrators" 
                secondary="Role-based access management. System security settings and maintenance. Custom report generation and data synchronization."
                primaryTypographyProps={{ fontSize: '1.2rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
              />
            </ListItemButton>
            <ListItemButton onClick={() => handleOpenVideo(videos.security)}>
              <ListItemIcon>
                <CircleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary="Training for Users" 
                secondary="Navigating the user interface. Managing personal settings and notifications. Utilizing reporting tools effectively."
                primaryTypographyProps={{ fontSize: '1.2rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
              />
            </ListItemButton>
          </List>
        </CardContent>
      </Card>

      <Dialog
        open={openVideo}
        onClose={handleCloseVideo}
        maxWidth="lg"
        fullWidth
      >
        <DialogContent>
          <video
            controls
            width="100%"
            autoPlay
            style={{ maxHeight: '80vh' }}
          >
            <source 
              src={currentVideo}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Documentation;
